import { useState, useEffect } from "react";
import { Box, Grid, Container, Typography } from "@mui/material";

import Page from "src/components/Page";
import { AppNewUsers, AppBugReports, AppItemOrders, AppWeeklySales, AppCurrentVisits, AppWebsiteVisits } from "src/components/_dashboard/app";
import { asyncRequest } from "src/services/network";

// ----------------------------------------------------------------------

export default function StatsPreview() {
  const [stats, setStats] = useState({
    revenue: 0,
    orders: 0,
    users: 0,
    charges: 0,

    payedOrders: 0,
    withdraws: 0,
  });

  useEffect(() => {
    getStats();
  }, []);

  async function getStats() {
    try {
      const { data } = await asyncRequest({
        method: "get",
        path: "/stats/preview",
      });

      setStats(data);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Page title="统计">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">统计</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppItemOrders
              title="总用户数"
              num={stats.users || 0}
              onClick={() => {
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppNewUsers
              title="总商家数"
              num={stats.merchants || 0}
              onClick={() => {
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales
              title="总让利额"
              num={stats.totalRangli || 0}
              onClick={() => {
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBugReports
              title="总消费券"
              num={stats.totalBalance || 0}
              onClick={() => {
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppNewUsers
              title="总补贴"
              num={stats.totalTransfered || 0}
              onClick={() => {
              }}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales
              title="总让利额"
              num={stats.totalPayed || 0}
              onClick={() => {
              }}
            />
          </Grid> */}
          
        </Grid>
      </Container>
    </Page>
  );
}
